module.exports = __webpack_public_path__ + "static/media/martin.dcced741.jpeg";